import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_7 = { class: "ui-button-content" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_12 = { class: "ant-col ant-col-xs-16 ant-col-xl-16" }
const _hoisted_13 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_16 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_17 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-20 ant-col-xl-20" }
const _hoisted_23 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Adicionar Acesso")
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_29 = ["onUpdate:modelValue", "disabled"]
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_31 = ["onUpdate:modelValue", "disabled"]
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Copiar Link")
], -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Remover")
], -1)
const _hoisted_40 = [
  _hoisted_39
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_combo_segurado = _resolveComponent("combo-segurado")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_combo_cidade = _resolveComponent("combo-cidade")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_card = _resolveComponent("card")!
  const _component_combo_usuario = _resolveComponent("combo-usuario")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cadastro_segurado_modal = _resolveComponent("cadastro-segurado-modal")!

  return (_openBlock(), _createBlock(_component_card, {
    titulo: "DADOS GERAIS DA INSPEÇÃO DO RISCO",
    "class-titulo": 'ui-card-info-titulo-rope'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_card, { titulo: "SEGURADO" }, {
              default: _withCtx(() => [
                ((_ctx.props.acessoExterno || _ctx.storeApp.state.usuarioAutenticado.codigo === 7))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_a_form_item, null, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_component_combo_segurado, {
                              codigo: _ctx.computedInspecao.codigoCadastro,
                              "onUpdate:codigo": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedInspecao.codigoCadastro) = $event)),
                              key: 'SEGUR-' + _ctx.computedInspecao.codigoCadastro,
                              disabled: true
                            }, null, 8, ["codigo"]))
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_a_form_item, null, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_component_combo_segurado, {
                              codigo: _ctx.computedInspecao.codigoCadastro,
                              "onUpdate:codigo": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedInspecao.codigoCadastro) = $event)),
                              key: 'SEGUR-' + _ctx.computedInspecao.codigoCadastro
                            }, null, 8, ["codigo"]))
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_a_form_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "ui-button -primary ui-full",
                              type: "button",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.apresentarCadastro()))
                            }, [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", null, _toDisplayString(_ctx.obtemCodigoCadastro() >0?'Visualizar Cadastro':'Cadastrar Segurado'), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])),
                _createVNode(_component_card, { titulo: "INFORMAÇÕES DO LOCAL" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_a_form_item, { label: "Local de Risco" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedInspecao.identificacaoLocal) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.computedInspecao.identificacaoLocal]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode(_component_a_spin, {
                      tip: "Consultando CEP...",
                      spinning: _ctx.consultandoCep
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_a_form_item, { label: "CEP" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_cep, {
                                  onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.consultaCep())),
                                  valor: _ctx.computedInspecao.cep,
                                  "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedInspecao.cep) = $event))
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_a_form_item, { label: "Endereço/Logradouro" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedInspecao.enderecoCompleto) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.computedInspecao.enderecoCompleto]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_a_form_item, { label: "Número" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedInspecao.numero) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.computedInspecao.numero]
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_a_form_item, { label: "Complemento" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.computedInspecao.complemento) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.computedInspecao.complemento]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_a_form_item, {
                              label: "Bairro",
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.computedInspecao.bairro) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.computedInspecao.bairro]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_a_form_item, { label: "Cidade/UF" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_combo_cidade, {
                                  codigo: _ctx.computedInspecao.codigoCidade,
                                  "onUpdate:codigo": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedInspecao.codigoCidade) = $event))
                                }, null, 8, ["codigo"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_a_form_item, { label: "Localização GPS (Check-in)" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  maxlength: "255",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedInspecao.localizacaoGpsCheckin) = $event)),
                                  disabled: _ctx.props.bloquearCampos
                                }, null, 8, _hoisted_20), [
                                  [_vModelText, _ctx.computedInspecao.localizacaoGpsCheckin]
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["spinning"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            ((!_ctx.props.acessoExterno || _ctx.storeApp.state.usuarioAutenticado.codigo))
              ? (_openBlock(), _createBlock(_component_card, {
                  key: 0,
                  titulo: "INFORMAÇÕES DA INSPEÇÃO"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_a_form_item, { label: "Responsável pela Inspeção" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_combo_usuario, {
                              codigo: _ctx.computedInspecao.codigoInspetorUsuario,
                              "onUpdate:codigo": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.computedInspecao.codigoInspetorUsuario) = $event))
                            }, null, 8, ["codigo"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_a_form_item, { label: "Data da Inspeção" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_data, {
                              dataSelecionada: _ctx.computedInspecao.dataInspecao,
                              "onUpdate:dataSelecionada": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.computedInspecao.dataInspecao) = $event))
                            }, null, 8, ["dataSelecionada"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ((!_ctx.props.acessoExterno))
              ? (_openBlock(), _createBlock(_component_card, {
                  key: 1,
                  style: {"display":"none"},
                  titulo: "ACESSOS"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("button", {
                          class: "ui-button -primary",
                          type: "button",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.adicionarAcesso()))
                        }, _hoisted_27)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedInspecao.acessos, (acesso, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'ACESSO-' + index,
                        class: "ant-row",
                        style: {"margin-top":"12px"}
                      }, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_a_form_item, {
                            label: "Nome",
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": ($event: any) => ((acesso.nome) = $event),
                                disabled: _ctx.props.bloquearCampos
                              }, null, 8, _hoisted_29), [
                                [_vModelText, acesso.nome]
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_a_form_item, {
                            label: "E-mail",
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "email",
                                class: "ant-input",
                                "onUpdate:modelValue": ($event: any) => ((acesso.email) = $event),
                                disabled: _ctx.props.bloquearCampos
                              }, null, 8, _hoisted_31), [
                                [_vModelText, acesso.email]
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_a_form_item, {
                            label: "Data de Liberação",
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: acesso.dataLiberacao,
                                "onUpdate:dataSelecionada": ($event: any) => ((acesso.dataLiberacao) = $event),
                                "hora-minuto-segundo": true,
                                disabled: _ctx.props.bloquearCampos
                              }, null, 8, ["dataSelecionada", "onUpdate:dataSelecionada", "disabled"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_a_form_item, { label: " " }, {
                            default: _withCtx(() => [
                              (acesso.codigo > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "ui-button -primary",
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.copiarLinkAcesso(acesso))
                                  }, _hoisted_36, 8, _hoisted_34))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(_component_a_form_item, { label: " " }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ui-button -danger",
                                type: "button",
                                onClick: ($event: any) => (_ctx.removerAcesso(index))
                              }, _hoisted_40, 8, _hoisted_38)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_cadastro_segurado_modal, {
          visivel: _ctx.state.apresentarCadastroSegurado,
          "onUpdate:visivel": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.apresentarCadastroSegurado) = $event)),
          codigoCadastro: _ctx.obtemCodigoCadastro(),
          onOperacaoConcluida: _ctx.cadastroAtualizado
        }, null, 8, ["visivel", "codigoCadastro", "onOperacaoConcluida"])
      ])
    ]),
    _: 1
  }))
}